import { Button as AntButton } from "antd";

import styles from "./Button.module.scss";

function Button(props) {
  const className = [
    props.variant === "small" ? styles.smallVariant : styles.largeVariant,
    props.type === "primary" ? styles.filled : styles.nonFilled
  ].join(" ");

  return (
    <AntButton className={`${className} ${styles.customStyle}`} {...props}>
      {props.children}
    </AntButton>
  );
}

export default Button;
